import React, { useState } from "react";
import { Modal } from "antd";
import {
  GrDocumentExcel,
  GrDocumentCsv,
  GrDocumentPdf,
  GrDocument,
} from "react-icons/gr";
import FileViewer from "react-file-viewer";
import { FaEye } from "react-icons/fa";
import { getUrlExtension } from "../../../../../../helpers/Utils";
import { colors } from "../../../../../../utils/colors";

const translates = {
  bigbox: {
    Title: "Title",
    Format: "Format",
    "Uploaded document": "Uploaded document",
    Download: "Download",
    Cancel: "Cancel",
  },
  technorama: {
    Title: "Pavadinimas",
    Format: "Formatas",
    "Uploaded document": "Dokumentas įkeltas",
    Download: "Parsisiųsti",
    Cancel: "Atšaukti"
  },
};

function DocumentItem({
  documents,
  deleteOrderDocument,
  identifier = "bigbox",
}) {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [modalInfo, setModalInfo] = useState({
    asset: { url: "" },
    id: 0,
    order_id: 0,
    title: "",
    created_at: "",
    format: "",
  });

  const showModal = (document) => {
    setModalInfo(document);
    setIsModalVisible(true);
  };

  const handleOk = () => {
    if (confirm("Are you sure wanna delete document ? ")) {
      deleteOrderDocument(modalInfo.order_id, modalInfo.id);
      setIsModalVisible(false);
    }
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  const formatIconRender = (format, img) => {
    if (format === "xlsx") {
      return <GrDocumentExcel size={30} />;
    } else if (format === "csv") {
      return <GrDocumentCsv size={30} />;
    } else if (format == "pdf") {
      return <GrDocumentPdf size={30} />;
    } else if (["png", "jpeg", "gif"].includes(format)) {
      return <img className="img-fluid" style={{ height: 90 }} src={img} />;
    } else {
      return <GrDocument size={30} />;
    }
  };

  return (
    <div className="col-12 pt-3">
      <div className="row">
        {documents.map((e) => {
          if (!e.format && e.asset?.url) {
            e.format = getUrlExtension(e.asset.url);
          }
          return (
            <div key={e.id} className="col-12 col-lg-6 mb-2">
              <div className="container-hover" onClick={() => showModal(e)}>
                <div className="card rounded p-3 cursor-pointer">
                  <div className="d-flex justify-content-center">
                    {formatIconRender(e.format, e.asset.url)}
                  </div>
                  {!["png", "jpeg", "gif"].includes(e.format) && (
                    <>
                      <div className="card-body p-0 pt-3">
                        <small>
                          Title: {e.title}
                          <br />
                          Format: {e.format}
                        </small>
                      </div>
                    </>
                  )}
                </div>

                <div className="bg-white">
                  <FaEye className="grow cursor-pointer" />
                </div>
              </div>
            </div>
          );
        })}
      </div>
      <Modal
        title={modalInfo.title}
        visible={isModalVisible}
        onOk={handleOk}
        okButtonProps={
          !deleteOrderDocument && {
            style: {
              display: "none",
            },
          }
        }
        onCancel={handleCancel}
        width={1000}
        okText="Remove"
        cancelText={translates[identifier]["Cancel"]}
      >
        <div className="d-flex justify-content-between">
          {["png", "jpeg", "gif"].includes(modalInfo.format) ? (
            <div style={{ flex: 4 }}>
              <img className="img-fluid" src={modalInfo.asset.url} />
            </div>
          ) : ["pdf"].includes(modalInfo.format) ? (
            <div style={{ flex: 4 }}>
              <embed
                src={modalInfo.asset.url}
                width="100%"
                height="450"
                frameBorder="0"
              ></embed>
            </div>
          ) : (
            <div style={{ flex: 4 }}>
              <FileViewer
                fileType={modalInfo.format}
                filePath={modalInfo.asset.url}
                errorComponent={<div />}
                onError={(e) => console.log("Error: : ", e)}
              />
            </div>
          )}
          <div className="pl-2" style={{ flex: 1 }}>
            <ul>
              <li>
                <span className="font-weight-bold">
                  {translates[identifier]["Title"]}:{" "}
                </span>
                {modalInfo.title}
              </li>
              <hr />
              <li>
                <span className="font-weight-bold">
                  {translates[identifier]["Format"]}:{" "}
                </span>
                {modalInfo.format}
              </li>
              <hr />
              <li>
                <span className="font-weight-bold">
                  {translates[identifier]["Uploaded document"]}:{" "}
                </span>
                {modalInfo.created_at.substr(0, 10)}
              </li>
              <br />
              <a
                className="btn btn-primary btn-block"
                style={{
                  backgroundColor:
                    identifier == "bigbox" ? colors.primary : colors.technorama,
                  borderColor:
                    identifier == "bigbox" ? colors.primary : colors.technorama,
                }}
                href={`${modalInfo.asset.url}`}
                download
              >
                {translates[identifier]["Download"]}
              </a>
            </ul>
          </div>
        </div>
      </Modal>
    </div>
  );
}

export default DocumentItem;
